import Color from "color";
import secureRandom from "../Random/random";
export const convertColorFormat = (color, toFormat) => {

    //please refere this link https://www.codemotion.com/magazine/frontend/javascript/the-best-color-manipulation-library-in-javascript/

    const colorObject = Color(color);
    let convertedColor;

    try {
        switch (toFormat) {
            case 'rgb':
                convertedColor = colorObject.rgb().toString();
                break;
            case 'hsl':
                convertedColor = colorObject.hsl().toString();
                break;
            case 'Hwb':
                convertedColor = colorObject.hwb().toString();
                break;
            case 'Cmyk':
                convertedColor = colorObject.cmyk().toString();
                break;
            case 'hex':
                convertedColor = colorObject.hex().toString();
                break;
            case 'xyz':
                convertedColor = colorObject.xyz().toString();
                break;
            case 'lab':
                convertedColor = colorObject.lab().toString();
                break;
            case 'lch':
                convertedColor = colorObject.lch().toString();
                break;
            case 'ansi16':
                convertedColor = colorObject.ansi16().toString();
                break;
            case 'ansi256':
                convertedColor = colorObject.ansi256().toString();
                break;
            case 'hcg':
                convertedColor = colorObject.hcg().toString();
                break;
            case 'apple':
                convertedColor = colorObject.apple().toString();
                break;
            default:
                console.error('Invalid target color format');
                return color;
        }
    } catch (error) {
        return color;
    }

    return convertedColor;
};
export const newShade = (hexColor, magnitude) => {
    let hexColorChange;
    const convertedColor2 = convertColorFormat(hexColor, 'hex');
    hexColorChange = convertedColor2.replace(`#`, ``);
    if (hexColorChange.length === 6) {
        const decimalColor = parseInt(hexColorChange, 16);
        let r = (decimalColor >> 16) + magnitude;
        r > 255 && (r = 255);
        r < 0 && (r = 0);
        let g = (decimalColor & 0x0000ff) + magnitude;
        g > 255 && (g = 255);
        g < 0 && (g = 0);
        let b = ((decimalColor >> 8) & 0x00ff) + magnitude;
        b > 255 && (b = 255);
        b < 0 && (b = 0);
        return `#${(g | (b << 8) | (r << 16)).toString(16)}`;
    } else {
        return hexColorChange;
    }
};

const generatedColors = new Set();
export const generateColor = () => {
    let color;
    do {
        color = `#${Math.floor(secureRandom() * 16777215).toString(16).padStart(6, '0')}`;
    } while (generatedColors.has(color));

    generatedColors.add(color);
    return color;
};

export const createStripePattern = (color) => {
    const canvas = document.createElement("canvas");
    canvas.width = 3;
    canvas.height = 6;
    const ctx = canvas.getContext("2d");

    ctx.strokeStyle = color;
    ctx.lineWidth = 2;

    // Draw vertical lines
    ctx.beginPath();
    ctx.moveTo(2, 0);
    ctx.lineTo(2, 6);
    ctx.stroke();

    return {
        image: canvas,
        repeat: "repeat"
    };
};

export const getYAxisIndex = () => ({ // y-axis index minimum of 3 slots 
    minInterval: 1,
    min: 0,
    max: (value) => {
        const yAxisMaxData = 2;
        const Yindex = 3;
        const valueMax = value?.max || 0;
        return valueMax <= yAxisMaxData ? Yindex : null;
    },
});

export const calculateVisibleCount = (start, end, totalBars) => {
    if (totalBars <= 0) return 0;
    const count = Math.round(((end - start) / 100) * totalBars);
    return Math.max(1, count);
};

export const syncZoomAndLabels = (
    start,
    end,
    totalBars,
    zoomStartRef,
    zoomEndRef,
    xAxisTruncateLabel,
    isZoomedToOne,
    setIsZoomedToOne
) => {
    if (start !== undefined) zoomStartRef.current = start;
    if (end !== undefined) zoomEndRef.current = end;

    if (xAxisTruncateLabel) {
        const isCurrentlyOne =
            calculateVisibleCount(
                zoomStartRef.current,
                zoomEndRef.current,
                totalBars
            ) === 1;
        if (isZoomedToOne !== isCurrentlyOne) {
            setIsZoomedToOne(isCurrentlyOne);
        }
    } else if (isZoomedToOne) {
        setIsZoomedToOne(false);
    }
};

export const formatYAxis = (value) => {
    if (value >= 1_000_000_000_000) {
        return `${value / 1_000_000_000_000}T`;
    } // Convert to T (trillions)
    if (value >= 1_000_000_000) {
        return `${value / 1_000_000_000}B`;
    } // Convert to B (billions)
    if (value >= 1_000_000) {
        return `${value / 1_000_000}M`;
    } // Convert to M (millions)
    if (value >= 1_000) {
        return `${value / 1_000}K`;
    } // Convert to K (thousands)
    return value;
};

export const nameGapYAxis = (maxDigits) => {
    let nameGap = 29; // Default value for 2-digit numbers
    if (maxDigits === 3) {
        nameGap = 40;
    } else if (maxDigits === 4) {
        nameGap = 45;
    } else if (maxDigits === 5) {
        nameGap = 48;
    } else if (maxDigits === 6) {
        nameGap = 50;
    } else if (maxDigits === 7) {
        nameGap = 52;
    } else if (maxDigits === 13) {
        nameGap = 77;
    }
    return nameGap;
};

export const YaxisTruncate = function (value) {
    return value.length > 4 ? value.substring(0, 4) + "..." : value;
};
